// SmsPhraseGql.js
import {gql} from '@apollo/client';

export const CustInfoDictionary = {
    inputMap: {
    },
    // To get common-response data
    queryName: {Add:'smsPhraseAdd', Edit:'smsPhraseEdit', Remove:'smsPhraseRemove'},
};

export const GET_SMS_PHRASE_LIST = gql`
  query getSmsPhraseList {
    smsPhraseList {
      custId
      phraseId
      phrase
      regUserId
      regTime
    }
  }
`;

export const ADD_SMS_PHRASE = gql`
mutation AddSmsPhrase($smsPhrase:InputSmsPhraseAdd!) {
  smsPhraseAdd(smsPhrase: $smsPhrase) {
    ok
    message
  }
}
`;

export const EDIT_SMS_PHRASE = gql`
mutation EditSmsPhrase($smsPhrase:InputSmsPhraseEdit!) {
  smsPhraseEdit(smsPhrase: $smsPhrase) {
    ok
    message
  }
}
`;

export const REMOVE_SMS_PHRASE = gql`
mutation RemoveSmsPhrase($smsPhrase:InputSmsPhraseRemove!) {
  smsPhraseRemove(smsPhrase: $smsPhrase) {
    ok
    message
  }
}
`;
